import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// The new Olli design's styles (built by scripts/olli-css.js). After index.css on purpose.
import './olli/styles/olli.generated.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
